import { render, staticRenderFns } from "./GlobalPaginate.vue?vue&type=template&id=f8d45bb0&scoped=true&"
import script from "./GlobalPaginate.vue?vue&type=script&lang=js&"
export * from "./GlobalPaginate.vue?vue&type=script&lang=js&"
import style0 from "./GlobalPaginate.vue?vue&type=style&index=0&id=f8d45bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d45bb0",
  null
  
)

export default component.exports